// @flow
export type ModelCategory = {
  _id: string,
  label: string,
  description: string,
  iconSmall: string,
  iconMedium: string,
  iconLarge: string,
};

/**
 */
class ModelCategoryModel {
  _modelCategory: ModelCategory;

  constructor(modelCategory: ModelCategory) {
    this._modelCategory = modelCategory;
  }

  /**
   * Id of the category
   */
  get key(): string {
    return this._modelCategory._id;
  }

  /**
   * Label of the category
   */
  get label(): string {
    return this._modelCategory.label;
  }

  /**
   * Description of the category
   */
  get description(): string {
    return this._modelCategory.description;
  }

  /**
   * Small icon of the category
   */
  get iconSmall(): string {
    return this._modelCategory.iconSmall;
  }

  /**
   * Medium icon of the category
   */
  get iconMedium(): string {
    return this._modelCategory.iconMedium;
  }

  /**
   * Large icon of the category
   */
  get iconLarge(): string {
    return this._modelCategory.iconLarge;
  }
}

export default ModelCategoryModel;
